import { render, staticRenderFns } from "./FriendsPage.vue?vue&type=template&id=4235e600&scoped=true"
import script from "./FriendsPage.vue?vue&type=script&lang=js"
export * from "./FriendsPage.vue?vue&type=script&lang=js"
import style0 from "./FriendsPage.vue?vue&type=style&index=0&id=4235e600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4235e600",
  null
  
)

export default component.exports